var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoutePoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.99996,
    cy: 9.99984,
    r: 3.33333,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99996 7.08342C8.38913 7.08342 7.08329 8.38925 7.08329 10.0001C7.08329 11.6109 8.38913 12.9167 9.99996 12.9167C11.6108 12.9167 12.9166 11.6109 12.9166 10.0001C12.9166 8.38925 11.6108 7.08342 9.99996 7.08342ZM2.91663 10.0001C2.91663 6.08806 6.08794 2.91675 9.99996 2.91675C13.912 2.91675 17.0833 6.08806 17.0833 10.0001C17.0833 13.9121 13.912 17.0834 9.99996 17.0834C6.08794 17.0834 2.91663 13.9121 2.91663 10.0001Z",
    fill: "#AA8768"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoutePoint);
export default __webpack_public_path__ + "static/media/RoutePoint.0bb031e9cf9db9d2811792f46c6db89d.svg";
export { ForwardRef as ReactComponent };